const require_richText = require("../types/value/richText.cjs");
//#region src/richtext/types.ts
const RichTextReversedNodeType = {
	[require_richText.RichTextNodeType.listItem]: "listItem",
	[require_richText.RichTextNodeType.oListItem]: "oListItem",
	[require_richText.RichTextNodeType.list]: "list",
	[require_richText.RichTextNodeType.oList]: "oList"
};
//#endregion
exports.RichTextReversedNodeType = RichTextReversedNodeType;

//# sourceMappingURL=types.cjs.map